// extracted by mini-css-extract-plugin
module.exports = {"inner":"ForgotPasswordForm_inner__aXDo4","formInner":"ForgotPasswordForm_formInner__fLBkY","form":"ForgotPasswordForm_form__tnbyG","alert":"ForgotPasswordForm_alert__MCOax"};